export enum PROFILE_TABS {
  POSTS = 'POSTS',
  SAVES = 'SAVED'
}

export enum AUTH_TABS {
  LOGIN = 'LOGIN',
  SIGNUP = 'SIGNUP',
  FORGOT = 'FORGOT'
}

export enum PROFILE_USERS_PAGE {
  FOLLOWERS = 'followers',
  FOLLOWINGS = 'followings'
}

export enum USER_TYPE {
  COMPANY = 'COMPANY',
  EMPLOYEE = 'EMPLOYEE'
}

export enum USER_ROLES {
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  VIEWER = 'VIEWER',
  EXTERNAL = 'EXTERNAL',
  ASSETS = 'ASSETS',
  SALES = 'SALES',
  SALES_LIMITED = 'SALES_LIMITED',
  PURCHASES = 'PURCHASES',
  PURCHASES_LIMITED = 'PURCHASES_LIMITED',
  POLICIES = 'POLICIES',
  FORMS = 'FORMS',
  PAGES = 'PAGES',
  DOCUMENTS = 'DOCUMENTS'
}

export const USER_ROLE_OPTIONS = [
  { value: USER_ROLES.ADMIN, label: USER_ROLES.ADMIN },
  { value: USER_ROLES.EDITOR, label: USER_ROLES.EDITOR },
  { value: USER_ROLES.VIEWER, label: USER_ROLES.VIEWER },
  { value: USER_ROLES.EXTERNAL, label: USER_ROLES.EXTERNAL },
  { value: USER_ROLES.ASSETS, label: USER_ROLES.ASSETS },
  { value: USER_ROLES.SALES, label: USER_ROLES.SALES },
  { value: USER_ROLES.SALES_LIMITED, label: USER_ROLES.SALES_LIMITED },
  { value: USER_ROLES.PURCHASES, label: USER_ROLES.PURCHASES },
  { value: USER_ROLES.PURCHASES_LIMITED, label: USER_ROLES.PURCHASES_LIMITED },
  { value: USER_ROLES.POLICIES, label: USER_ROLES.POLICIES },
  { value: USER_ROLES.DOCUMENTS, label: USER_ROLES.DOCUMENTS }
];

export enum USER_STATUS {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE'
}

export enum SETTING_TABS {
  GENERAL = 'general',
  CHANGE_PASSWORD = 'change-password',
  DELETE_ACCOUNT = 'delete-account',
  LOGOUT = 'logout'
}

export enum BUSINESS_TYPE {
  FREE = 'FREE',
  PREMIUM = 'PREMIUM',
  SILVER = 'SILVER',
  GOLD = 'GOLD',
  PLATINUM = 'PLATINUM',
  CUSTOM = 'CUSTOM'
}

export interface USER {
  uuid: string;
  type: string;
  userUuid: string;
  frndUuid: string;
  name: string;
  username: string;
  image: string;
  about: string;
  isOnline: string;
  lastActive: string;
  isFollowing: number;
  created: string;
}
